(function () {
  var bar = document.getElementById('sticky-cta');
  var mainBtn = document.getElementById('add-to-cart');
  if (!bar || !mainBtn || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var scrolledPast = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('show', scrolledPast);
    });
  }, { threshold: 0 });
  io.observe(mainBtn);
})();
// ---- GALLERY SWITCHER ----
function switchImg(btn, src, alt) {
  document.querySelectorAll('.thumb-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  const main = document.getElementById('main-img');
  main.style.opacity = '0';
  setTimeout(() => {
    main.src = src;
    main.alt = alt;
    main.style.opacity = '1';
  }, 180);
}

// ---- VARIANT SWATCHES (couleurs) ----
function selectVariant(btn) {
  var id = btn.getAttribute('data-variant-id');
  var img = btn.getAttribute('data-image');
  var label = btn.getAttribute('data-label');
  var price = btn.getAttribute('data-price');
  var available = btn.getAttribute('data-available') === 'true';

  document.querySelectorAll('.variant-swatch').forEach(function (s) {
    s.classList.remove('active'); s.setAttribute('aria-checked', 'false');
  });
  btn.classList.add('active'); btn.setAttribute('aria-checked', 'true');

  // input panier
  var form = document.getElementById('ltdm-product-form');
  var input = form && form.querySelector('[name="id"]');
  if (input) input.value = id;

  // image principale
  if (img) {
    var main = document.getElementById('main-img');
    if (main) {
      main.style.opacity = '0';
      setTimeout(function () { main.src = img; main.alt = label || main.alt; main.style.opacity = '1'; }, 180);
    }
    document.querySelectorAll('.thumb-btn').forEach(function (b) { b.classList.remove('active'); });
  }

  // label courant
  var lab = document.getElementById('variant-current-label');
  if (lab && label) lab.textContent = label;

  // prix (variantes au même prix ici, mais on reste juste si ça change)
  if (price) {
    var priceEl = document.querySelector('.hero-price');
    var activeTier = document.querySelector('.qty-tier.active');
    var qty = activeTier ? (parseInt(activeTier.getAttribute('data-qty')) || 1) : 1;
    if (priceEl && qty === 1) {
      var cmp = btn.getAttribute('data-compare');
      if (cmp && cmp !== price && cmp.indexOf('0,00') === -1) {
        priceEl.innerHTML = '<s class="hero-price-was">' + cmp + '</s> <span class="hero-price-now">' + price + '</span>';
      } else { priceEl.innerHTML = price; }
    }
  }

  // URL ?variant=ID (sans recharger)
  try {
    var url = new URL(window.location.href);
    url.searchParams.set('variant', id);
    history.replaceState({}, '', url);
  } catch (e) {}

  // dispo → bouton panier
  var addBtn = document.getElementById('add-to-cart');
  if (addBtn) {
    addBtn.disabled = !available;
    if (!available && !addBtn.classList.contains('added')) {
      addBtn.dataset.origHtml = addBtn.dataset.origHtml || addBtn.innerHTML;
      addBtn.innerHTML = 'Indisponible dans ce coloris';
    } else if (available && addBtn.dataset.origHtml) {
      addBtn.innerHTML = addBtn.dataset.origHtml;
      delete addBtn.dataset.origHtml;
    }
  }
}

// ---- ACCESSOIRE : variante + quantité + ajout panier ----
function pickAccVariant(sel) {
  var opt = sel.options[sel.selectedIndex];
  var form = document.getElementById('ltdm-product-form');
  var input = form && form.querySelector('[name="id"]');
  if (input) input.value = opt.value;
  var priceEl = document.querySelector('.hero-price');
  if (priceEl && opt.getAttribute('data-price')) priceEl.innerHTML = opt.getAttribute('data-price');
  var addBtn = document.getElementById('add-to-cart');
  if (addBtn) addBtn.disabled = opt.disabled;
  try { var url = new URL(window.location.href); url.searchParams.set('variant', opt.value); history.replaceState({}, '', url); } catch (e) {}
}
function accQty(e, delta) {
  e.preventDefault();
  var el = document.getElementById('acc-qty-val');
  if (!el) return;
  var q = Math.max(1, Math.min(20, (parseInt(el.textContent) || 1) + delta));
  el.textContent = q;
}
function addAccessoire(btn) {
  var form = document.getElementById('ltdm-product-form');
  if (!form) return;
  var variantId = form.querySelector('[name="id"]').value;
  var qEl = document.getElementById('acc-qty-val');
  var qty = qEl ? (parseInt(qEl.textContent) || 1) : 1;
  var orig = btn.innerHTML;
  btn.disabled = true; btn.classList.add('added');
  btn.innerHTML = '<svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg> Eh hop, dans le panier ! 🐾';
  fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] }) })
    .then(function (r) { return r.json(); })
    .then(function () { window.location.href = '/cart'; })
    .catch(function () { btn.disabled = false; btn.classList.remove('added'); btn.innerHTML = orig; });
}

// ---- TABS ----
function switchTab(id) {
  document.querySelectorAll('.tab-btn').forEach(b => {
    b.classList.remove('active');
    b.setAttribute('aria-selected', 'false');
  });
  document.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));

  document.getElementById('btn-' + id).classList.add('active');
  document.getElementById('btn-' + id).setAttribute('aria-selected', 'true');
  document.getElementById('tab-' + id).classList.add('active');
}

// Peek : à la 1re apparition de la barre d'onglets, la surbrillance glisse sur les 5 onglets
(function () {
  const nav = document.querySelector('.tabs-nav');
  if (!nav || !('IntersectionObserver' in window)) return;
  const btns = Array.from(nav.querySelectorAll('.tab-btn'));
  let played = false;
  const io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting && !played) {
        played = true;
        io.disconnect();
        btns.forEach(function (b, i) {
          setTimeout(function () {
            btns.forEach(function (x) { x.classList.remove('peek'); });
            b.classList.add('peek');
            if (i === btns.length - 1) setTimeout(function () { b.classList.remove('peek'); }, 400);
          }, i * 320);
        });
      }
    });
  }, { threshold: 0.6 });
  io.observe(nav);
})();

// ---- AVIS TOGGLE ----
function toggleAvis() {
  const hidden = document.getElementById('avis-hidden');
  const btn = document.getElementById('toggle-avis-btn');
  if (!hidden || !btn) return;
  const isOpen = hidden.classList.contains('show');
  const remaining = btn.getAttribute('data-remaining') || hidden.querySelectorAll('.avis-card, [class*="avis"]').length;

  if (isOpen) {
    hidden.classList.remove('show');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9"/></svg> Afficher les ' + remaining + ' autres avis';
  } else {
    hidden.classList.add('show');
    btn.setAttribute('aria-expanded', 'true');
    btn.innerHTML = '<svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><polyline points="18 15 12 9 6 15"/></svg> Masquer les avis';
  }
}

// ---- ADD TO CART ----
function selectTier(btn) {
  document.querySelectorAll('.qty-tier').forEach(function (t) {
    t.classList.remove('active'); t.setAttribute('aria-checked', 'false');
  });
  btn.classList.add('active'); btn.setAttribute('aria-checked', 'true');
  const total = btn.getAttribute('data-total');
  const qty = parseInt(btn.getAttribute('data-qty')) || 1;
  const priceEl = document.querySelector('.hero-price');
  if (priceEl && total) priceEl.innerHTML = total;

  // livraison offerte cumulée (24,99 € / litière)
  const shipEl = document.getElementById('ship-value');
  if (shipEl) shipEl.innerHTML = (qty * 24.99).toFixed(2).replace('.', ',') + ' €';

  // jouets offerts cumulés (1 / litière, valeur 19,99 €)
  const giftEl = document.getElementById('gift-offer-text');
  if (giftEl) {
    const s = qty > 1 ? 's' : '';
    const val = (qty * 19.99).toFixed(2).replace('.', ',');
    giftEl.innerHTML = '<span class="gift-offer-tag">🎁 Offert' + s + '</span> ' + qty +
      ' <strong>jouet' + s + ' interactif' + s + ' intelligent' + s + '</strong> pour chat ' +
      '<span class="gift-offer-val">(valeur ' + val + ' €)</span> · 1 par litière.';
  }
}

function stepQty(e, delta) {
  e.preventDefault(); e.stopPropagation();
  // générique : on cible le stepper de l'accessoire cliqué, pas un id figé
  const item = e.target.closest('.crosssell-item');
  if (!item) return;
  const el = item.querySelector('[id$="-qty"]');
  if (!el) return;
  let q = (parseInt(el.textContent) || 1) + delta;
  q = Math.max(1, Math.min(20, q));
  el.textContent = q;
  // toucher la quantité coche automatiquement l'accessoire
  const check = item.querySelector('.crosssell-check');
  if (check && !check.checked) check.checked = true;
  updateCrosssell();
}
function pickCrosssellVariant(sel) {
  var opt = sel.options[sel.selectedIndex];
  var item = sel.closest('.crosssell-item');
  if (!item) return;
  var check = item.querySelector('.crosssell-check');
  if (check) {
    check.setAttribute('data-variant-id', opt.value);
    check.setAttribute('data-price', opt.getAttribute('data-price'));
    check.checked = true;
  }
  var priceEl = item.querySelector('.crosssell-price');
  if (priceEl && opt.getAttribute('data-money')) priceEl.innerHTML = opt.getAttribute('data-money');
  updateCrosssell();
}
function updateCrosssell() {
  const checks = Array.from(document.querySelectorAll('.crosssell-check'));
  let total = 0, n = 0;
  checks.forEach(function (c) {
    if (c.checked) {
      let p = parseFloat(c.getAttribute('data-price'));
      const qid = c.getAttribute('data-qtyid');
      if (qid) {
        const qEl = document.getElementById(qid + '-qty');
        if (qEl) p *= (parseInt(qEl.textContent) || 1);
      }
      total += p; n++;
    }
  });
  const btn = document.getElementById('btn-crosssell');
  if (!btn) return;
  if (n === 0) { btn.disabled = true; btn.textContent = 'Sélectionnez un accessoire'; }
  else { btn.disabled = false; btn.innerHTML = 'Ajouter la sélection · ' + total.toFixed(2).replace('.', ',') + ' €'; }
}
function addCrosssell(btn) {
  const checks = Array.from(document.querySelectorAll('.crosssell-check'));
  const chosen = checks.filter(function (c) { return c.checked; });
  if (!chosen.length) return;
  const items = chosen.map(function (c) {
    const id = c.getAttribute('data-variant-id');
    let q = 1;
    const qid = c.getAttribute('data-qtyid');
    if (qid) {
      const el = document.getElementById(qid + '-qty');
      q = el ? (parseInt(el.textContent) || 1) : 1;
    }
    return { id: id, quantity: q };
  }).filter(function (i) { return i.id; });
  if (!items.length) return;
  btn.disabled = true;
  btn.textContent = '✓ Ajouté au panier !';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: items })
  }).then(function () { window.location.href = '/cart'; })
    .catch(function () { btn.disabled = false; setTimeout(updateCrosssell, 800); });
}

// Sélecteur d'extension de garantie Minette Care (même comportement que selectTier).
function selectCare(btn) {
  const wrap = btn.parentElement;
  if (!wrap) return;
  const all = wrap.querySelectorAll('.care-tier');
  for (let i = 0; i < all.length; i++) {
    all[i].classList.remove('active');
    all[i].setAttribute('aria-checked', 'false');
  }
  btn.classList.add('active');
  btn.setAttribute('aria-checked', 'true');
}

function handleAddToCart(btn) {
  const form = document.getElementById('ltdm-product-form');
  if (!form) return;
  const variantId = form.querySelector('[name="id"]').value;
  const tier = document.querySelector('.qty-tier.active');
  const qty = tier ? (parseInt(tier.getAttribute('data-qty')) || 1) : 1;
  const items = [{ id: variantId, quantity: qty }];
  // Jouet offert : auto-ajout du cadeau (uniquement sur les fiches marquées data-gift-variant = litières)
  const giftVariant = form.getAttribute('data-gift-variant');
  if (giftVariant) { items.push({ id: parseInt(giftVariant, 10), quantity: qty }); }
  // Extension de garantie Minette Care : strictement opt-in, l'option "Sans extension" a data-care-variant vide.
  const careTier = document.querySelector('.care-tier.active');
  const careVariant = careTier ? careTier.getAttribute('data-care-variant') : '';
  if (careVariant) { items.push({ id: parseInt(careVariant, 10), quantity: qty }); }
  const orig = btn.innerHTML;
  btn.disabled = true;
  btn.classList.add('added');
  btn.innerHTML = '<svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg> Eh hop, très bon choix ! 🐾';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: items })
  }).then(function (r) { return r.json(); })
    .then(function () { window.location.href = '/cart'; })
    .catch(function () {
      btn.disabled = false;
      btn.classList.remove('added');
      btn.innerHTML = orig;
    });
}

// ---- STORIES ----
// storyData est fourni par la section ltdm-stories (window.storyData), généré depuis les blocks éditables.
function openStory(id) {
  const data = (window.storyData || {})[id];
  if (!data) return;
  const vid = document.getElementById('story-video');
  const gif = document.getElementById('story-gif');
  const bg = document.querySelector('.story-placeholder-bg');
  const play = document.querySelector('.story-play-icon');
  // reset media
  vid.pause(); vid.style.display = 'none';
  gif.style.display = 'none'; gif.removeAttribute('src');
  if (bg) bg.style.display = '';
  if (play) play.style.display = '';
  if (data.video) {
    vid.src = data.video; vid.style.display = 'block';
    if (bg) bg.style.display = 'none';
    if (play) play.style.display = 'none';
    vid.currentTime = 0; vid.play().catch(function(){});
  } else if (data.gif) {
    gif.src = data.gif; gif.alt = data.title; gif.style.display = 'block';
    if (bg) bg.style.display = 'none';
    if (play) play.style.display = 'none';
  }
  document.getElementById('story-modal-title').textContent = data.title;
  document.getElementById('story-modal-body').textContent = data.body;
  const modal = document.getElementById('story-modal');
  modal.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeStory() {
  const vid = document.getElementById('story-video');
  if (vid) { vid.pause(); }
  document.getElementById('story-modal').classList.remove('open');
  document.body.style.overflow = '';
}

function goFullscreen() {
  const el = document.getElementById('story-modal-content');
  if (el.requestFullscreen) el.requestFullscreen();
  else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
}

// Close modal on backdrop click (guard : #story-modal n'existe que sur les fiches produit)
var _storyModal = document.getElementById('story-modal');
if (_storyModal) {
  _storyModal.addEventListener('click', function(e) {
    if (e.target === this) closeStory();
  });
}

// Keyboard: Escape closes modal
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closeStory();
});

// Story bubble keyboard support
document.querySelectorAll('.story-bubble').forEach(b => {
  b.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
  });
});

// ---- CALCULATEUR AUTONOMIE ----
function calcRenderIcons(el, n, emoji) {
  const cur = el.querySelectorAll('span').length;
  el.innerHTML = Array.from({length: n}, () => `<span>${emoji}</span>`).join('');
}
function calcAnimateNum(el, to) {
  const from = parseInt(el.textContent) || 0;
  if (from === to) { el.textContent = to; return; }
  const steps = Math.min(Math.abs(to - from), 18);
  const dur = 420, t0 = performance.now();
  function frame(t) {
    const p = Math.min((t - t0) / dur, 1);
    const eased = 1 - Math.pow(1 - p, 3);
    el.textContent = Math.round(from + (to - from) * eased);
    if (p < 1) requestAnimationFrame(frame); else el.textContent = to;
  }
  requestAnimationFrame(frame);
}
function calcAutonomie() {
  var _rc = document.getElementById('range-chats');
  var _rl = document.getElementById('range-litieres');
  if (!_rc || !_rl) return; // pas de calculateur sur cette page
  const chats = parseInt(_rc.value) || 1;
  const litieres = parseInt(_rl.value) || 1;
  const inner = document.querySelector('.calc-inner');
  const autoMax = (inner && parseInt(inner.getAttribute('data-autonomie'))) || 14;
  const jours = Math.max(1, Math.floor((litieres * autoMax) / chats));

  document.getElementById('val-chats').textContent = chats;
  document.getElementById('val-litieres').textContent = litieres;
  calcRenderIcons(document.getElementById('icons-chats'), chats, '🐱');
  calcRenderIcons(document.getElementById('icons-litieres'), litieres, '🚽');
  calcAnimateNum(document.getElementById('calc-result-num'), jours);

  // jauge : autonomie max = plein
  const pct = Math.min((jours / autoMax) * 100, 100);
  document.getElementById('calc-gauge-fill').style.width = pct + '%';

  const result = document.getElementById('calc-result');
  let state, advice;
  if (jours >= autoMax) {
    state = 'great';
    advice = 'Parfait pour des vacances prolongées ! Votre chat sera serein en votre absence.';
  } else if (jours >= 7) {
    state = 'good';
    advice = 'Confortable pour une semaine de déplacement. Pensez à faire vider une fois si vous partez plus longtemps.';
  } else if (jours >= 3) {
    state = 'ok';
    advice = 'Autonomie correcte pour un week-end. Pour plus de confort, envisagez une litière supplémentaire.';
  } else {
    state = 'low';
    advice = 'Avec autant de chats, ajoutez une litière pour maintenir un confort optimal.';
  }
  result.setAttribute('data-state', state);
  document.getElementById('calc-advice').textContent = advice;
}
document.addEventListener('DOMContentLoaded', calcAutonomie);

// ---- FORMULAIRE ----
function handleFormSubmit(e) {
  e.preventDefault();
  const form = document.getElementById('contact-form');
  const name = document.getElementById('f-name').value.trim();
  const email = document.getElementById('f-email').value.trim();
  const msg = document.getElementById('f-msg').value.trim();
  const errEl = document.getElementById('form-error');

  if (!name || !email || !msg) {
    if (errEl) errEl.style.display = 'block';
    return;
  }
  if (errEl) errEl.style.display = 'none';

  const done = function () {
    form.style.display = 'none';
    document.getElementById('form-success').style.display = 'block';
  };
  const url = form.getAttribute('data-collector-url');
  const key = form.getAttribute('data-collector-key');
  const site = form.getAttribute('data-site') || 'ltdm';
  if (url && key) {
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'apikey': key,
        'Authorization': 'Bearer ' + key,
        'Prefer': 'return=minimal'
      },
      body: JSON.stringify({ site: site, name: name, email: email, message: msg, source: 'product-form' })
    }).then(done).catch(done);
  } else {
    console.warn('[LTDM] Collecteur non configuré (collector_url/collector_key) : lead NON envoyé.');
    done();
  }
}

// ---- SCROLL REVEAL (IntersectionObserver) ----
const reveals = document.querySelectorAll('.reveal, .reveal-left, .reveal-right');
function revealAll() { reveals.forEach(el => el.classList.add('visible')); }
if (!('IntersectionObserver' in window)) {
  // pas d'IO → on montre tout (jamais de contenu caché)
  revealAll();
} else {
  const revealObs = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        revealObs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
  reveals.forEach(el => revealObs.observe(el));
  // filet de sécurité : rien ne reste jamais invisible (si l'observer rate, JS lent, crawler, etc.)
  setTimeout(revealAll, 2500);
}

// ---- COMPTEUR qui monte sur les chiffres clés ----
function countUp(el) {
  const target = parseInt(el.getAttribute('data-count')) || 0;
  const suffix = el.getAttribute('data-suffix') || '';
  const dur = 1100, t0 = performance.now();
  function frame(t) {
    const p = Math.min((t - t0) / dur, 1);
    const eased = 1 - Math.pow(1 - p, 3);
    el.textContent = Math.round(target * eased) + suffix;
    if (p < 1) requestAnimationFrame(frame); else el.textContent = target + suffix;
  }
  requestAnimationFrame(frame);
}
const statObs = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) { countUp(entry.target); statObs.unobserve(entry.target); }
  });
}, { threshold: 0.6 });
document.querySelectorAll('.point-stat[data-count]').forEach(el => statObs.observe(el));

// ---- TITRE D'ONGLET : re-engagement quand on quitte l'onglet ----
(function () {
  var originalTitle = document.title;
  var awayTitle = "🐱 Reviens ! Ton chat t'attend 🎁";
  document.addEventListener('visibilitychange', function () {
    document.title = document.hidden ? awayTitle : originalTitle;
  });
})();

// ---- DIAGONALE QUI BASCULE AU SCROLL (section Technologie) ----
(function () {
  var sec = document.querySelector('.storytelling-section');
  if (!sec || !('IntersectionObserver' in window)) return;
  var active = false, raf = false, MAX = 46; // px : demi-amplitude du décalage
  function clampSwing(edgeY, vh) {
    // p = 0 quand l'arête est en bas du viewport, 1 quand elle est en haut ; bascule à 60 %
    var p = Math.max(0, Math.min(1, (vh - edgeY) / vh));
    return Math.max(-MAX, Math.min(MAX, (0.6 - p) * 2.4 * MAX));
  }
  function update() {
    raf = false;
    var r = sec.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    // chaque diagonale suit la position de SON arête dans le viewport (haut vs bas)
    var sTop = clampSwing(r.top, vh);
    var sBot = clampSwing(r.bottom, vh);
    sec.style.setProperty('--cut-tl', (MAX + sTop).toFixed(1) + 'px');
    sec.style.setProperty('--cut-tr', (MAX - sTop).toFixed(1) + 'px');
    sec.style.setProperty('--cut-bl', (MAX + sBot).toFixed(1) + 'px');
    sec.style.setProperty('--cut-br', (MAX - sBot).toFixed(1) + 'px');
  }
  function onScroll() { if (active && !raf) { raf = true; requestAnimationFrame(update); } }
  // n'écoute le scroll que quand la section est visible (perf)
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { active = e.isIntersecting; if (active) update(); });
  }, { threshold: 0 });
  io.observe(sec);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
})();
